import LocationShape from './LocationShape'
import BlankLocationKnownShape from './BlankLocationKnownShape'

export default LocationShape
export { BlankLocationKnownShape }
